if (!customElements.get('customer-form')) {
  customElements.define(
    'customer-form',
    class CustomerForm extends HTMLElement {
      constructor () {
        super();
        this.form = null;
        this.type = this.getAttribute('data-type');
        this.formErrors = null;
      }

      getFormData () {
        let data = null;
        this.form.querySelectorAll('input').forEach((item) => {
          if (item.name) {
            if (data === null) {
              data = {};
            }
            data[item.name] = item.value;
          }
        });
        return data;
      }

      getFormBody (data) {
        return Object.keys(data).map((key) => {
          return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
        }).join('&');
      }

      setError (value = '<li>Unexpected error</li>') {
        if (this.formErrors) {
          this.formErrors.querySelector('ul').innerHTML = value;
          this.formErrors.style.display = 'block';
        }
      }

      handleSubmit(event) {
        event.preventDefault();
        this.formErrors.style.display = 'none';

        const captchaField = this.form.querySelector('[data-hcaptcha-response]');

        if (!captchaField) {
          console.log('[Captcha Skipped] No CAPTCHA present, submitting directly');
          this.sendRequestWithCaptcha(null);
          return;
        }

        captchaField.setAttribute('data-hcaptcha-response', '');

        const waitForCaptcha = () => {
          const captchaValue = captchaField.getAttribute('data-hcaptcha-response');
          if (captchaValue) {
            console.log('[Captcha Ready] Sending with token:', captchaValue);
            this.sendRequestWithCaptcha(captchaValue);
          } else {
            setTimeout(waitForCaptcha, 100);
          }
        };

        this.form.requestSubmit();
        waitForCaptcha();
      }


      sendRequestWithCaptcha (captchaToken = null) {
        const data = this.getFormData();
        const action = this.form.getAttribute('action');
        if (!data || !action) {
          this.setError();
          return;
        }

        if (captchaToken) {
          data['h-captcha-response'] = captchaToken;
        }

        const formBody = this.getFormBody(data);
        const returnURL = this.form.querySelector('[name=return_to]')?.value ?? '/';

        fetch(action, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: formBody,
        }).then((response) => {
          if (response.status === 200) {
            response.text().then((content) => {
              const _content = document.createElement('html');
              _content.innerHTML = content;
              const body = _content.querySelector('body');
              const isLogged = body.hasAttribute('data-islogged') && body.getAttribute('data-islogged') * 1 === 1;
              const isLoginAction = this.type === 'login';
              const errors = _content.querySelector(`form[action="${action}"] .form__message + .errors ul`);
              if (errors) {
                this.setError(errors.innerHTML);
              } else if (isLoginAction) {
                console.log('body.classList.contains(\'wpd-b2b-customer\')=', body.classList.contains('wpd-b2b-customer'));
                if (body.classList.contains('wpd-b2b-customer')) {
                  window.location.replace(returnURL);
                } else {
                  this.setError(
                    `<li>Your Pro Account is not currently active! Please email <a href="mailto::pros@smallwonder.world">pros@smallwonder.world</a> for assistance.</li>`);
                  const email = data['customer[email]'] || null;
                  this.sendEmail(email, 'A user without pro access tried to log in with a pro account');
                }
              } else if (isLogged) {
                window.location.replace(returnURL);
              }
            });
          } else {
            throw new Error('Unexpected error');
          }
        }).catch((error) => {
          console.error('Error:', error);
          this.setError(`<li>${error?.message ?? 'Unexpected error'}</li>`);
        });
      }

      sendEmail (email, errorMessage) {
        let storage = sessionStorage.getItem(`failed-emails`);
        try {
          if (storage) {
            storage = JSON.parse(storage);
          }
        } catch (e) {
          console.error(e);
        } finally {
          if (!storage) {
            storage = [];
          }
        }

        try {
          if (typeof emailjs !== 'undefined' && !storage.includes(email)) {
            emailjs.init('DEgGIJo0vcGAZEkae');
            const serviceID = 'default_service';
            const templateID = 'template_tibns7d';
            const emailParams = {
              user_email: email,
              error_message: errorMessage,
            };
            emailjs.send(serviceID, templateID, emailParams).then(function (response) {
              console.log('Email successfully sent!', response.status, response.text);
            }).catch(function (error) {
              console.error('Email failed to send', error);
            });
          }
        } catch (e) {
          console.error(e);
        }

        storage.push(email);
        sessionStorage.setItem(`failed-emails`, JSON.stringify(storage));
      }

      connectedCallback () {
        this.form = this.querySelector('form');
        if (this.form) {
          this.formErrors = this.form.querySelector('.errors-wrapper');

          this.form.originalSubmit = this.form.submit;
          this.form.submit = () => {
            console.log('[Intercepted] Shopify native form.submit() call blocked');
            return false;
          };

          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }

      disconnectedCallback () {
        if (this.form) {
          this.form.removeEventListener('submit', this.handleSubmit.bind(this));
        }
      }
    },
  );
}
